<template>
	<div class="grid gap-4">
		<FormKit
			type="loanlinkCurrency"
			name="originalDebt"
			label="Oorspronkelijke schuld"
		/>
		<FormKit
			type="loanlinkCurrency"
			name="currentDebt"
			label="Huidige schuld"
		/>
		<FormKit
			type="loanlinkNumeric"
			name="remainingMonths"
			label="Resterende maanden"
		/>
		<FormKit type="loanlinkDate" name="endDate" label="Einddatum" />
		<FormKit
			type="loanlinkPercentage"
			name="interestRate"
			label="Rentepercentage"
		/>
		<FormKit
			type="loanlinkCurrency"
			name="fixedMonthlyAmount"
			label="Vastesteld maandbedrag"
		/>
		<FormKit
			type="loanlinkOption"
			name="settledForNewMortgage"
			label="Afgelost voor nieuwe hypotheek"
			:options="{ true: 'Ja', false: 'Nee' }"
		/>
	</div>
</template>
